import React from 'react';
import { useFormikContext } from 'formik';
import FormItem from '../../../components/Form/FormItem';
import FieldSet from '../../../components/Form/FieldSet';
import Label from '../../../components/Form/Label';
import Input from '../../../components/Form/Input';
import Select from '../../../components/Form/Select';
import Title from '../../../components/Title';
import { UserData } from '../../../types/userData';

export interface Props {
  title?: string;
}

const InternationalPurchaseAddressForm = ({ title }: Props) => {
  const { values, handleChange } = useFormikContext<UserData>();

  const secondText = 'Você não pode editar essa informação';

  return (
    <>
      {values && (values.siscoserv?.country || values.siscoserv?.address) && (
        <FormItem>
          {title && <Title>{title}</Title>}
          <FieldSet>
            <Label htmlFor="country">País</Label>
            <Select
              id="country"
              onChange={handleChange}
              value={values.siscoserv.country}
              name="siscoserv.country"
              disabled
              aria-label={`${secondText}`}
            >
              <option value={undefined}>Selecione um país</option>
              <option value="Estados Unidos">Estados Unidos</option>
            </Select>
          </FieldSet>
          <FieldSet>
            <Label htmlFor="address">Endereço</Label>
            <Input
              id="address"
              readOnly
              name="siscoserv.address"
              onChange={handleChange}
              aria-label={`${secondText}`}
              value={values.siscoserv.address}
            />
          </FieldSet>
          <FieldSet>
            <Label htmlFor="nif">Documento NIF</Label>
            <Input
              id="nif"
              readOnly
              value={values.siscoserv.nif}
              aria-label={`${secondText}`}
              onChange={handleChange}
              name="siscoServ.nif"
            />
          </FieldSet>
        </FormItem>
      )}
    </>
  );
};

export default InternationalPurchaseAddressForm;
